import styled from '@emotion/styled';
import { Input } from 'antd';
import { InputProps } from 'antd/lib/input';
import React from 'react';

export interface IPasswordProps extends InputProps {
  style?: React.CSSProperties;
}

const Password: React.FC<IPasswordProps> = ({ style, ...props }) => {
  return <Input.Password style={style} {...props} />;
};

export default styled(Password)`
  &.ant-input-affix-wrapper {
    border-radius: 2px;
  }
`;
